import {
    getSurvey,
    getOptionalSurvey,
    saveOptionalSkillClusters,
    SkillClusterType,
} from '../actions/surveyActions';
import Button from '../components/Button';
import CircleIcon from '../components/CircleIcon';
import OptionalSkillGrid from '../components/optional-skill-grid';
import { Domain } from '../model/models';
import { State } from '../redux-state';
import breakpoints from '../styles/breakpoints';
import colors from '../styles/colors';
import { globalColor } from '../utils/globals';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { NavLink, useLocation, useNavigate, useParams } from 'react-router-dom';
import styled from 'styled-components';

const Container = styled.div`
    display: flex;
    justify-content: Space-between;
    padding-top: 25px;
    align-items: center;
`;
const HeaderSection = styled.div``;
const HeaderRow = styled.div``;
const LeftLabels = styled.div`
    display: flex;
    align-items: center;
    gap: 10px;
`;
const GlanceLabel = styled.span`
    font-size: 18px;
    font-weight: 600;
    color: green;
    text-transform: uppercase;
    ${breakpoints.onlyMobile} {
    }
`;
const OptionalLabel = styled.span`
    font-size: 14px;
    /* padding: 2px 2px; */
    border-radius: 6px;
    font-weight: 500;
    color: #333;
    width: 188px;
    height: 31px;
    border-radius: 4px;
    display: flex;
    justify-content: center;
    align-items: center;
    background: #d9d9d9;
    ${breakpoints.onlyMobile} {
    }
`;
const Title = styled.h2`
    font-size: 22px;
    font-weight: bold;
    margin: 8px 0;
    ${breakpoints.onlyMobile} {
        font-size: 20px;
    }
`;
const Instructions = styled.div`
    font-size: 14px;
    color: #000000;
    line-height: 1.4;
    font-style: italic;
    ${breakpoints.onlyMobile} {
        font-size: 12px;
    }
`;
const Notes = styled.p`
    font-style: italic;
    margin-left: 40px;
    margin-top: 0;
    margin-bottom: 0;
    ${breakpoints.onlyMobile} {
        margin-left: 0px;
        margin-top: 5px;
        margin-bottom: 5px;
    }
`;
const NotesContainer = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
`;
const LogoImageContainer = styled.div`
     {
        display: flex;
        display: flex;
        justify-content: flex-start;
    }
`;
const OptionalSurveyContainer = styled.div`
    width: 100%;
    padding: 0px 40px 7px 40px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    background: #fcfcfc;
    ${breakpoints.onlyMobile} {
        padding: 20px 20px 7px 20px;
    }
`;
const LogoImage = styled.img`
    max-height: 120px;
    margin-right: 10%;
    object-fit: contain;
    ${breakpoints.lg} {
        margin-right: 10%;
    }
    ${breakpoints.onlyMobile} {
        max-width: 25%;
        width: 100%;
    }
    ${breakpoints.md} {
        margin-right: 10%;
    }
`;
const StyledNavLink = styled(NavLink)`
    display: flex;
    flex-direction: column;
    text-decoration: none;
    width: 200px;
    margin-right: 30px;
    span {
        color: ${colors.textColor1};
    }
    &:hover span,
    &:visited span,
    &:active span {
        color: ${colors.textColor1};
    }
`;
const BottomSectionContainer = styled.div`
    display: flex;
    min-height: calc(100vh - 310px);
    width: 100%;
    margin-top: 10px;
    ${breakpoints.onlyMobile} {
        width: 100%;
        height: 100%;
        min-height: unset;
        flex-direction: column;
    }
`;
const InfoImageIcon = styled(CircleIcon)`
    width: 13px;
    height: 13px;
    border-radius: unset;
    background-size: unset;
    margin: 0 6px;
`;
const FullWidthButton = styled(Button)`
    width: 274px;
    font-size: 20px;
    &:focus-visible {
        outline: none;
    }
    &.previous {
        margin-right: 20px;
    }
    ${breakpoints.onlyMobile} {
        width: 150px;
        font-size: 16px;
    }
`;
const ButtonsContainer = styled.div<{ backgroundColor?: string }>`
    display: flex;
    align-items: center;
    justify-content: flex-end;
    padding: 20px 0;
    ${breakpoints.onlyMobile} {
        position: fixed;
        bottom: 0;
        z-index: 9;
        display: flex;
        align-items: center;
        justify-content: center;
        width: calc(100vw - 39px) !important;
        background-color: ${(props) => props.backgroundColor || '#FBFBFB'};
        padding: 12px 0;
        margin: 0;
        display: flex;
        align-items: center;
        justify-content: space-between;
    }
`;
interface OptionalSkillDomainGridProps {
    onToggle: (id: string, checked: boolean) => void;
    selectedIds: string[];
}
const OptionalSkillDomainGrid: React.FC<OptionalSkillDomainGridProps> = ({
    onToggle,
    selectedIds,
}) => {
    const optionalDomains: Domain[] = useSelector(
        (state: State): Domain[] => state.optionalSurveyState.domains,
    );
    return (
        <OptionalSkillGrid
            data={optionalDomains}
            onToggle={onToggle}
            selectedIds={selectedIds}
        />
    );
};
function useIsMobile(breakpoint = 768) {
    const [isMobile, setIsMobile] = useState(window.innerWidth <= breakpoint);
    useEffect(() => {
        const handleResize = () => setIsMobile(window.innerWidth <= breakpoint);
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, [breakpoint]);
    return isMobile;
}
const OptionalSurvey: React.FC = () => {
    const { t } = useTranslation(['OptionalSurvey']);
    const logoImageSrc: string = useSelector(
        (state: State): string => state.surveyState.logoSrc || '',
    );
    const dispatch = useDispatch();
    let emailAuth: any, levels_state: any;
    const { survey_id, uid } = useParams();
    const navigate = useNavigate();
    const location = useLocation();
    const stateVar = location.state;
    if (stateVar) {
        if ('emailAuth' in stateVar) {
            emailAuth = stateVar.emailAuth;
        }
        if ('levels_state' in stateVar) {
            levels_state = stateVar.levels_state;
        }
    }
    if (!emailAuth) {
        const storedEmailAuth = sessionStorage.getItem('emailAuth');
        if (storedEmailAuth) {
            emailAuth = storedEmailAuth;
        }
    }
    const domains: Domain[] = useSelector(
        (state: State): Domain[] => state.optionalSurveyState.domains,
    );
    const [selectedIds, setSelectedIds] = useState<string[]>([]);
    const [initialSelectedIds, setInitialSelectedIds] = useState<string[]>([]);
    const [selectionChanged, setSelectionChanged] = useState(false);

    useEffect(() => {
        if (!domains || domains.length === 0) {
            dispatch(getOptionalSurvey(survey_id, uid, false));
        }
    }, []);

    useEffect(() => {
        const ids = domains
            .filter((domain) => domain.isSelected)
            .map((domain) => domain.id.toString());
        setSelectedIds(ids);
        // Store initial selection to track changes
        setInitialSelectedIds(ids);
    }, [domains]);
    // Handler to update selected IDs
    const handleToggle = (id: string, checked: boolean) => {
        setSelectedIds((prev) => {
            const newSelection = checked
                ? [...prev, id]
                : prev.filter((item) => item !== id);

            // Compare with initial selection to detect changes
            const hasChanged = !areSelectionsEqual(
                newSelection,
                initialSelectedIds,
            );
            setSelectionChanged(hasChanged);

            return newSelection;
        });
    };

    // Helper function to compare selections
    const areSelectionsEqual = (selection1: string[], selection2: string[]) => {
        if (selection1.length !== selection2.length) return false;
        const sorted1 = [...selection1].sort();
        const sorted2 = [...selection2].sort();
        return sorted1.every((val, idx) => val === sorted2[idx]);
    };
    const performNext = () => {
        if (selectedIds.length > 0) {
            const targetUrl = `/${survey_id}/${uid}/survey/${selectedIds[0]}?type=${SkillClusterType.OPTIONAL}`;
            // Use replace to avoid navigation history issues
            navigate(targetUrl, {
                state: {
                    levels_state: levels_state,
                    emailAuth: emailAuth,
                },
            });
        } else {
            const nextPath = `/${survey_id}/${uid}/mandatory-welcome`;
            navigate(nextPath, {
                state: {
                    levels_state: levels_state,
                    emailAuth: emailAuth,
                },
            });
        }
    };
    const handleFinishSurvey = async () => {
        const previousPath = `/${survey_id}/${uid}/mandatory-welcome`;
        // Wait for the first action to complete
        const ids = domains
            .filter((domain) => domain.isSelected)
            .map((domain) => domain.id.toString());
        await dispatch(saveOptionalSkillClusters(survey_id, uid, ids));

        // Wait for the second action to complete
        await dispatch(getOptionalSurvey(survey_id, uid, false));

        const navigationTimeout = setTimeout(() => {
            navigate(previousPath, {
                state: {
                    levels_state: levels_state,
                    emailAuth: emailAuth,
                },
            });
        }, 100); // Small delay of 50ms

        // Only have one return statement in the cleanup function
        return () => clearTimeout(navigationTimeout);
        // Only proceed to navigation after both actions have completed
    };
    const sendSelectedIds = async () => {
        // Wait for the first action to complete
        await dispatch(saveOptionalSkillClusters(survey_id, uid, selectedIds));
        // Wait for the second action to complete
        await dispatch(getOptionalSurvey(survey_id, uid, false));
        // Only proceed to navigation after both actions have completed
        performNext();
    };
    const isMobile = useIsMobile();
    return (
        <OptionalSurveyContainer>
            {isMobile && (
                <LogoImageContainer>
                    <LogoImage src={`data:image/jpeg;base64,${logoImageSrc}`} />
                </LogoImageContainer>
            )}
            <Container>
                <HeaderSection>
                    <HeaderRow></HeaderRow>
                    <Title>{t('title')}</Title>
                    <Instructions>
                        <p
                            style={{ marginBottom: '0px' }}
                            dangerouslySetInnerHTML={{ __html: t('note1') }}
                        />
                        <Notes
                            dangerouslySetInnerHTML={{ __html: t('note2') }}
                        />
                    </Instructions>
                </HeaderSection>
                {!isMobile && (
                    <LogoImageContainer>
                        <LogoImage
                            src={`data:image/jpeg;base64,${logoImageSrc}`}
                        />
                    </LogoImageContainer>
                )}
            </Container>
            <BottomSectionContainer>
                <OptionalSkillDomainGrid
                    onToggle={handleToggle}
                    selectedIds={selectedIds}
                />
            </BottomSectionContainer>
            <ButtonsContainer>
                <FullWidthButton
                    className="previous"
                    borderColor={globalColor.primaryButton}
                    textColor={globalColor.primaryButton}
                    buttonType="secondary"
                    onClick={handleFinishSurvey}
                >
                    {t('FinishSurvey')}
                </FullWidthButton>
                <FullWidthButton
                    className="next"
                    buttonType="primary"
                    onClick={sendSelectedIds}
                    disabled={selectedIds.length === 0 && !selectionChanged}
                >
                    {t('Continue')}
                </FullWidthButton>
            </ButtonsContainer>
        </OptionalSurveyContainer>
    );
};
export default OptionalSurvey;
